/**
 * External dependencies.
 */
import { Trans } from "@lingui/macro";

/**
 * Internal dependencies
 */
import Articles from "components/articles/articles";

const PopularArticles = ({ articles }: any) => {
  return (
    <div className="popular-articles">
      <div className="container">
        <div className="popular-articles__inner">
          <h4>
            <Trans>Popular articles</Trans>
          </h4>

          <Articles
            articles={articles}
            pagination={false}
          />
        </div>
      </div>
    </div>
  );
};

export default PopularArticles;
